import React, { memo, useState, useEffect } from 'react'
import Image from 'next/image'
import { FormattedMessage, useIntl } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Collapse from '@mui/material/Collapse'
import useMediaQuery from '@mui/material/useMediaQuery'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { addTestIdProp } from 'utils/universal'
import Link from 'next/link'
import Text, { TEXT_TYPES } from 'components/designSystem/Text'
import useUtms from 'hooks/useUtms'
import Divider from '@mui/material/Divider'
import BuenasManos from 'public/img/sell-your-car/buenasmanos.svg'
import Sucursal from 'public/img/sell-your-car/sucursal.svg'
import TestDrive from 'public/img/sell-your-car/testdrive.svg'
import SinSalir from 'public/img/sell-your-car/sinsalir.svg'
import SellFastItem from 'components/shared/SellFastItem/SellFastItem'
import sx from './styles'

const Makes = (props) => {
  const {
    title,
    description,
    note,
    makes = [],
    sx: sxProp,
    testId: testIdProp,
    expanded = true,
    collapsable = true,
    cardFormat = false,
    soldFast = false,
    variant = 'column',
    showButton,
    buttonText,
    buttonRedirect,
    variantRedirect = 'vta', // vta, srp
  } = props
  const { formatMessage: f } = useIntl()
  const [isVisibleDropDown, setIsVisibleDropDown] = useState(false)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const query = useUtms()

  const textDropDownBtn = isVisibleDropDown ? 'Ver menos' : 'Ver más'

  const sxDropDownButon = !isVisibleDropDown
    ? { ...sx.dropDownButtonContainer, ...sx.dropDownButtonContainerUp }
    : { ...sx.dropDownButtonContainer, ...sx.dropDownButtonContainerDown }

  useEffect(() => {
    setIsVisibleDropDown((prev) => !prev)
  }, [expanded])

  const renderMake = (make) => {
    const redirectUrl = variantRedirect === 'vta'
      ? `${f({ id: 'ROUTE_QUOTE_CAR' }, { step: f({ id: 'ROUTE_QUOTE_CAR_STEP_YEAR' }) })}${query}`
      : `/${f({ id: 'ROUTE_SEARCH' })}/marca-${make.name.toLowerCase()}${query}`
    return (
      <Grid
        size={{
          xs: 5,
          md: 5,
          lg: 5,
        }}
        key={`makes-${make.name}`}
      // sx={sx.item}
      >
        <Link
          href={redirectUrl}
          passHref
        >
          <Text type={TEXT_TYPES.link.text}>
            <Image
              src={make.image}
              alt={make.name}
              fill
              style={{ objectFit: 'contain' }}
              blurDataURL={make.image}
            />
          </Text>
        </Link>
      </Grid>
    )
  }
  const renderRow = (make) => {
    const redirectUrl = variantRedirect === 'vta'
      ? `${f({ id: 'ROUTE_QUOTE_CAR' }, { step: f({ id: 'ROUTE_QUOTE_CAR_STEP_YEAR' }) })}${query}`
      : `${f({ id: 'ROUTE_SEARCH' })}/marca-${make.name.toLowerCase()}${query}`
    return (
      <Box
        sx={sx.widthPerItemInRowVariant}
        key={`make-row-${make.name}`}
      >
        <Link
          href={redirectUrl}
          passHref
        >
          <Image
            src={make.image}
            alt={make.name}
            layout="fill"
            objectFit="contain"
            blurDataURL={make.image}
          />
        </Link>
      </Box>
    )
  }

  const sellFastInfo = [
    {
      id: 1,
      icon: (<BuenasManos />),
      title: 'SYC_FAST_INFO_ITEM_1_TITLE',
      description: 'SYC_FAST_INFO_ITEM_1_DESCRIPTION',
    },
    {
      id: 2,
      icon: (<Sucursal />),
      title: 'SYC_FAST_INFO_ITEM_2_TITLE',
      description: 'SYC_FAST_INFO_ITEM_2_DESCRIPTION',
    },
    {
      id: 3,
      icon: (<TestDrive />),
      title: 'SYC_FAST_INFO_ITEM_3_TITLE',
      description: 'SYC_FAST_INFO_ITEM_3_DESCRIPTION',
    },
    {
      id: 4,
      icon: (<SinSalir />),
      title: 'SYC_FAST_INFO_ITEM_4_TITLE',
      description: 'SYC_FAST_INFO_ITEM_4_DESCRIPTION',
    },
  ]

  return (
    <Box
      sx={{ ...sx.root, ...sxProp }}
      id="section2"
      {...addTestIdProp(testIdProp)}
    >
      <Container>
        <Grid
          container
          justifyContent="center"
          sx={cardFormat ? (isMobile ? sx.containerMobile : sx.container) : {}}
        >
          <Grid size={12}>
            <Typography
              sx={sx.title}
              variant="h3"
            >
              {title}
            </Typography>
            {description && (
              <Typography
                component="p"
                variant="subtitle1"
                sx={sx.description}
              >
                {description}
              </Typography>
            )}
          </Grid>
          {collapsable && (
            <Collapse
              in={isVisibleDropDown}
              collapsedSize={140}
              timeout={1000}
              sx={sx.dropDown}
            >
              <Grid
                size={12}
                justifyContent="center"
                container
              >
                {makes.map(renderMake)}
              </Grid>
            </Collapse>
          )}
          {variant === 'row' && (
            <Grid
              size={12}
              justifyContent="space-between"
              container
              py={2}
            >
              {makes.map(renderRow)}
            </Grid>
          )}
          {isMobile && variant !== 'row' && (
            <Box
              sx={sxDropDownButon}
            >
              <Typography
                variant="caption"
                onClick={() => setIsVisibleDropDown((prev) => !prev)}
                sx={sx.dropDownButton}
              >
                {textDropDownBtn}
              </Typography>
              <Typography
                variant="caption"
                onClick={() => setIsVisibleDropDown((prev) => !prev)}
                sx={sx.dropDownButton}
              >
                {isVisibleDropDown ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </Typography>
            </Box>
          )}
          {note && (
            <Grid
              size={12}
            >
              <Typography
                variant="body2"
                sx={sx.note}
                align="center"
              >
                {note}
              </Typography>
            </Grid>
          )}
          {showButton && (
            <Grid
              size={12}
            >
              <Link
                href={buttonRedirect}
                passHref
              >
                <Button
                  color="primary"
                  variant="outlined"
                  fullWidth={isMobile}
                  arial-label={f({ id: 'QUOTE_NOW' })}
                  sx={sx.button}
                >
                  <FormattedMessage id={buttonText || 'QUOTE_NOW'} />
                </Button>
              </Link>
            </Grid>
          )}
          {
            soldFast && (
              <>
                <Divider style={{
                  broder: '1px solid red', height: '2px', width: '100%', marginTop: '20px',
                }}
                />
                <Grid
                  size={12}
                  mt={5}
                >
                  <Typography
                    sx={sx.title}
                    variant="h3"
                  >
                    {f({ id: 'SYC_SOLD_FAST_TITLE' })}
                  </Typography>
                  {description && (
                    <Typography
                      component="p"
                      variant="subtitle1"
                      sx={sx.description}
                    >
                      {f({ id: 'SYC_SOLD_FAST_SUBTITLE' })}
                    </Typography>
                  )}
                </Grid>

                <Grid container>
                  {
                    sellFastInfo.map((item) => (
                      <Grid
                        size={{
                          xs: 12,
                          sm: 3,
                        }}
                        key={item.id}
                      >
                        <SellFastItem
                          title={item.title}
                          description={item.description}
                          icon={item.icon}
                        />
                      </Grid>
                    ))
                  }
                </Grid>
              </>
            )
          }
        </Grid>
      </Container>
    </Box>
  )
}

export default memo(Makes)
